import * as R from "ramda";

import { isBlank } from "utils/func";
import { adminEmphasis } from "utils/sharedStyles";

export const PAYMENT_PROCESSORS = {
  none: "none",
  citybase: "citybase",
  stripe: "stripe",
  spreedly: "spreedly",
};

export const getAccelaACAGuidanceMarkdown = R.path([
  "accela_configuration_attributes",
  "aca_guidance_markdown",
]);
export const getAccelaACAName = R.pathOr("ACA", ["accela_configuration_attributes", "aca_name"]);
export const getBounds = R.prop("bounds");
export const getCenter = R.prop("center");
export const getDisclaimer = R.prop("disclaimer");
export const getFullName = R.prop("full_name");
export const getGeocoderName = R.prop("geocoder");
export const getGeocoderOptions = R.propOr({}, "geocoder_options");
export const getMunicipalityType = R.prop("municipality_type");
export const getName = R.prop("name");
export const getSealURL = (tenant, type) => R.compose(R.prop(type), getSealURLs)(tenant);
const getSealURLs = R.prop("seal_urls");
export const getSlug = R.prop("slug");
export const getTimezone = R.prop("timezone");
export const getUseCodes = R.propOr([], "use_codes");
export const getZoningClearanceHeader = R.prop("zoning_clearance_header");
export const isAccelaConnected = R.pathOr(false, ["accela_configuration_attributes", "connected"]);
export const isAccelaEnabled = R.compose(
  Boolean,
  R.path(["accela_configuration_attributes", "enabled"]),
);
export const getStateAbbreviation = R.prop("state_abbreviation");
export const getAddress = R.prop("address");
export const getZipcode = R.prop("zipcode");
export const getPhone = R.prop("phone");
export const getWebsiteURL = R.prop("website_url");

const getLanguages = R.prop("languages");

export const getActiveLanguages = R.compose(R.filter(R.propEq(true, "active")), getLanguages);
export const getIsMultilingual = R.pipe(getActiveLanguages, R.length, R.flip(R.gt)(1));

// Payments related
export const getCityBaseAPCInvoiceURL = R.path(["payments_config", "citybase_apc_invoice_url"]);
export const getSpreedlyKey = R.path(["payments_config", "spreedly_public_key"]);
export const getBackendPaymentProcessor = R.path(["payments_config", "backend_processor"]);
export const getPaymentProcessor = R.path(["payments_config", "processor"]);
export const getStripeKey = R.path(["payments_config", "stripe_public_key"]);
export const getArePaymentsRefundable = R.pathOr(false, ["payments_config", "refundable"]);

const formatColor = (color) => (color.match(/^#/) ? color : `#${color}`);
export const getColors = R.applySpec({
  primary: R.compose(formatColor, R.propOr(adminEmphasis, "color_one")),
  secondary: R.compose(formatColor, R.propOr(adminEmphasis, "color_two")),
});

export const getTenantVersionIsHead = R.compose(isBlank, R.prop("last_version"));
